import createStyle from './createStyle';
export const buildTypes = (typography, withColor, withLineHeight) => Object.keys(typography).reduce((acc, type) => ({
  ...acc,
  [type]: createStyle(typography[type], withColor, withLineHeight)
}), {});
//# sourceMappingURL=types.js.map